export const setAdminToken = (formData) => {
    return {
      type: 'SET_ADMIN_TOKEN',
      payload: formData,
    };
};


export const resetAdminToken = () => {
    return {
        type: 'RESET',
    }
}